import { useCallback, useReducer } from "react";

import useOnWindowResize from "~/hooks/useOnWindowResize";
import { isBrowser } from "~/utilities/helpers";

function tableLayoutReducer(state, action) {
    let updatedState = state;

    switch (action.type) {
        case "SET_HEIGHTS":
            const { filterHeight, paginationHeight } = action;
            updatedState = {
                ...state,
                filterHeight,
                paginationHeight,
            };
            break;
        default:
            if (isBrowser) {
                console.log(
                    `Unkown useTableLayout Reducer User Action ${action.type}`,
                );
            }
            break;
    }

    return updatedState;
}

function getElementHeight(element) {
    return element.getBoundingClientRect().height;
}

const tableLayoutInitialState = {
    filterHeight: 0,
    paginationHeight: 0,
};

const useTableLayoutHelpers = (filterWrapperRef, paginationWrapperRef) => {
    const [state, dispatch] = useReducer(
        tableLayoutReducer,
        tableLayoutInitialState,
    );

    useOnWindowResize(
        useCallback(() => {
            const filterHeight = filterWrapperRef?.current
                ? getElementHeight(filterWrapperRef.current)
                : 0;
            const paginationHeight = paginationWrapperRef?.current
                ? getElementHeight(paginationWrapperRef.current)
                : 0;

            dispatch({ type: "SET_HEIGHTS", filterHeight, paginationHeight });
        }, [filterWrapperRef, paginationWrapperRef]),
    );

    return {
        filterHeight: state.filterHeight,
        paginationHeight: state.paginationHeight,
    };
};

export default useTableLayoutHelpers;
